"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.diabetesMellitusTypeMessages = exports.diseasesMessages = exports.DiabetesMellitusType = exports.Diseases = void 0;
const schema_1 = require("../../../../../schema");
var Diseases;
(function (Diseases) {
    Diseases["DIABETES_MELLITUS"] = "diabetes_mellitus";
    Diseases["IMPAIRED_GLUCOSE_TOLERANCE"] = "impaired_glucose_tolerance";
    Diseases["THYROID_DISEASE"] = "thyroid_disease";
    Diseases["OTHER"] = "other";
})(Diseases || (exports.Diseases = Diseases = {}));
var DiabetesMellitusType;
(function (DiabetesMellitusType) {
    DiabetesMellitusType["IDDM"] = "IDDM";
    DiabetesMellitusType["NIDDM"] = "NIDDM";
})(DiabetesMellitusType || (exports.DiabetesMellitusType = DiabetesMellitusType = {}));
exports.diseasesMessages = {
    [Diseases.DIABETES_MELLITUS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.endocrineDiseases.diseases.DIABETES_MELLITUS",
        defaultMessage: "Diabetes mellitus"
    },
    [Diseases.IMPAIRED_GLUCOSE_TOLERANCE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.endocrineDiseases.diseases.IMPAIRED_GLUCOSE_TOLERANCE",
        defaultMessage: "Csökkent glükóztolerancia"
    },
    [Diseases.THYROID_DISEASE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.endocrineDiseases.diseases.THYROID_DISEASE",
        defaultMessage: "Pajzsmirigybetegség"
    },
    [Diseases.OTHER]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.endocrineDiseases.diseases.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.diabetesMellitusTypeMessages = {
    [DiabetesMellitusType.IDDM]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.endocrineDiseases.diabetesMellitusType.IDDM",
        defaultMessage: "IDDM"
    },
    [DiabetesMellitusType.NIDDM]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.endocrineDiseases.diabetesMellitusType.NIDDM",
        defaultMessage: "NIDDM"
    }
};
const diseases = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Diseases.DIABETES_MELLITUS),
    schema_1.Schema.singleChoiceItem(Diseases.IMPAIRED_GLUCOSE_TOLERANCE),
    schema_1.Schema.singleChoiceItem(Diseases.THYROID_DISEASE),
    schema_1.Schema.singleChoiceItem(Diseases.OTHER)
]).interpretation({ vocab: "ltx", code: "endocrine_disease" });
const diabetesMellitusType = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../diseases} === "diabetes_mellitus"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DiabetesMellitusType.IDDM),
    schema_1.Schema.singleChoiceItem(DiabetesMellitusType.NIDDM)
]).interpretation({ vocab: "ltx", code: "diabetes_mellitus_type" }));
const comment = schema_1.Schema.string()
    .optional()
    .maxLength(1000)
    .interpretation({ vocab: "ltx", code: "endocrine_disease_comment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ diseases, diabetesMellitusType, comment })
    .interpretation({ vocab: "ltx", code: "endocrine_disease_form" });
